import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzse = () => {
    return (
        <div>
             <NavLink to='/category/Puzzels/Puzzel8'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel6'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article
    class="container">
    <h1 class="title">3 Bulbs and 3 Switches</h1>
   
    <div class="text">
        <p>There is a room with a door (closed) and three light bulbs. Outside the room, there are three switches,
            connected to the bulbs. You may manipulate the switches as you wish, but once you open the door you can’t
            change them. Identify each switch with its bulb. All bulbs are in working condition.<br/>
           <div className='containers'>
            Let the bulbs be X,
            Y, and Z&nbsp;<br/>
            Turn on switch X for 5 to 10 minutes. Turn it off and turn on switch Y. Open the door and
            touch the light bulb.&nbsp;<br/>
            1. if the light is on, it is Y&nbsp;<br/>
            2. if the light is off and hot, it is
            X&nbsp;<br/>
            3. if the light is off and cold, it is Z&nbsp;</div></p>
       
    </div>
</article>
        </div>
    )
}

export default Puzse
